import { useContext } from 'react';

import { OrgUnitAthleteContactStateContext } from './OrgUnitAthleteContactContextProvider';

import OrgUnitAthleteContactData from './OrgUnitAthleteContactData';

const useOrgUnitAthleteContactData = () => {
  const [orgUnitAthleteContactState, setOrgUnitAthleteContactState] = useContext(OrgUnitAthleteContactStateContext);

  const getOrgUnitAthleteContacts = (omeMeetId, athletePersonId) => {
    OrgUnitAthleteContactData.getOrgUnitAthleteContactsData(omeMeetId, athletePersonId, orgUnitAthleteContactState, setOrgUnitAthleteContactState);
  };

  const postOrgUnitAthleteContact = (orgUnitAthleteContactObj) => {
    OrgUnitAthleteContactData.postOrgUnitAthleteContactData(orgUnitAthleteContactObj, orgUnitAthleteContactState, setOrgUnitAthleteContactState);
  };

  const putOrgUnitAthleteContact = (orgUnitAthleteContactId, orgUnitAthleteContactObj) => {
    OrgUnitAthleteContactData.putOrgUnitAthleteContactData(orgUnitAthleteContactId, orgUnitAthleteContactObj, orgUnitAthleteContactState, setOrgUnitAthleteContactState);
  };

  const deleteOrgUnitAthleteContact = (orgUnitAthleteContactId) => {
    OrgUnitAthleteContactData.deleteOrgUnitAthleteContactData(orgUnitAthleteContactId, orgUnitAthleteContactState, setOrgUnitAthleteContactState);
  };

  const confirmSaveOrgUnitAthleteContact = () => {
    setOrgUnitAthleteContactState({
      ...orgUnitAthleteContactState,
      isSaved: false
    });
  };

  const resetOrgUnitAthleteContactState = () => {
    setOrgUnitAthleteContactState(OrgUnitAthleteContactData.INITIAL_STATE);
  }

  return {
    orgUnitAthleteContactState,
    setOrgUnitAthleteContactState,
    getOrgUnitAthleteContacts,
    postOrgUnitAthleteContact,
    putOrgUnitAthleteContact,
    deleteOrgUnitAthleteContact,
    confirmSaveOrgUnitAthleteContact,
    resetOrgUnitAthleteContactState
  };
};

export default useOrgUnitAthleteContactData;